import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function QueryProvider({ children }: { children: React.ReactNode }) {
	const client = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				retry: false,
			},
		},
	});

	return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

export default QueryProvider;
